<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      事業者データベース一覧(STDSDC01C20)                                                                _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isBuisinessDBListShow">
    <div class="popup" style="width:654px">
      <div class="popup-head">事業者データベース一覧</div>
      <div class="popup-body blue">
        <!--****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage is-modal-error :errors="errors"></ErrorMessage>
        </p>
        <div class="table-scroll-header" style="margin-top: 0px;">
          <table class="table-select single-select">
            <colgroup>
              <col style="width: auto;">
              <col style="width: 200px;">
            </colgroup>
            <thead>
              <tr>
                <th class="alignleft sort hover" @click="changeSortKey('databaseName')">
                  データベース名称
                  <div class="sort-toggle">
                    <button class="sort-toggle-asc" :class="sort.key == 'databaseName' && sort.isAsc
                      ? 'on'
                      : ''
                      " type="button">
                      asc
                    </button>
                    <button class="sort-toggle-desc" :class="sort.key == 'databaseName' && !sort.isAsc
                      ? 'on'
                      : ''
                      " type="button">
                      desc
                    </button>
                  </div>
                </th>
                <th class="sort hover" @click="changeSortKey('dataUpdateDate')">
                  保存日時
                  <div class="sort-toggle">
                    <button class="sort-toggle-asc" :class="sort.key == 'dataUpdateDate' && sort.isAsc
                      ? 'on'
                      : ''
                      " type="button">
                      asc
                    </button>
                    <button class="sort-toggle-desc" :class="sort.key == 'dataUpdateDate' && !sort.isAsc
                      ? 'on'
                      : ''
                      " type="button">
                      desc
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-scroll-body" style="height: 250px; background-color: #ffffff" ref="cubeBopDbInfoTable">
          <table class="table-select single-select scroll" style="width: 100%; table-layout: fixed">
            <colgroup>
              <col style="width: auto;">
              <col style="width: 200px;">
            </colgroup>
            <tbody>
              <tr v-for="info in cubeBopDbInfoList" :key="info.databaseKeyName" @click="selectRow(info)" :class="[
                info.databaseKeyName == this.currentSelectDBKeyName
                  ? 'selected'
                  : '',
              ]"
              :id="[info.databaseKeyName]">
                <!--データベース名称-->
                <td><span>{{ info.databaseName }}</span></td>
                <!--保存日時-->
                <td class="aligncenter">
                  <span>
                    {{ formatDateTime_Date(info.dataUpdateDate) }}
                  </span>
                  <br />
                  <span>
                    {{ formatDateTime_Time(info.dataUpdateDate) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-select single-select" v-show="noDataPrompt">
            <tbody>
              <tr>
                <p class="noData-area">
                  {{ noDataMsg }}
                </p>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="errMsg alignleft" v-show="errors_selectDB != ''">
          <ErrorMessageCase :errors="errors_selectDB"></ErrorMessageCase>
        </p>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <button class="frm-btn strong large" data-role="popup-open" ref="confirmButton" @click="handleConfirm">
                確定
              </button>
              <button class="frm-btn large" data-role="popup-close" @click="handleCancel">
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import moment from "moment";
import BaseModal from "@/components/Base/BaseModal.vue";
import Common, { common } from "@/util/common";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import { API_DisplayCubeBopDbInfoListScreen } from "@/api/Modules/DC01/STDSDC01C20";
import { mapMutations } from "vuex";

export default {
  name: "STDSDC01C20",
  components: {
    BaseModal,
    ErrorMessage,
    ErrorMessageCase,
  },
  data() {
    return {
      pageID: "STDSDC01C20",  // ページID
      cubeBopDbInfoList: [],  // Cube事業者データベース情報リスト
      currentSelectedDBName: "",     // 選択中データベース名
      currentSelectDBKeyName:"",
      sort: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      errors_selectDB: [],    // 選択エラー
      errors: [],
      noDataPrompt: false,
      noDataMsg: Common.getMessage("MTCL1118", ["事業者データベース情報"]),
    };
  },
  props: {
    // 表示定義
    isBuisinessDBListShow: {
      type: Boolean,
      default: false,
      required: true,
    },
    // 選択中データベースキー名
    selectedDBKeyName: {
      type: String,
      default: "",
      required: true,
    }
  },
  
  watch: {
    isBuisinessDBListShow: function (newVal) {
      if (newVal) {
        this.sort.key = "";
        this.currentSelectedDBName = "";
        this.currentSelectDBKeyName = this.selectedDBKeyName;

        // エラー情報初期化
        this.clearError();

        // 「処理中」表示
        this.processDialogue(true);

        // 初期画面表示処理
        API_DisplayCubeBopDbInfoListScreen().then((response) => {
          if (response.result == "0000") {
            this.cubeBopDbInfoList = response.cubeBopDBInfoList;
            this.noDataPrompt = this.cubeBopDbInfoList.length == 0;
          } else {
            this.cubeBopDbInfoList = [];
            this.noDataPrompt = true;

            // エラー表示
            if (response.errorMSG) {
              this.errors.push(
                Common.createError(response.errorCD, response.errorMSG)
              );
            } else {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
        }).finally(() => {
          // データが存在しなかった場合は選択状態初期化
          if (this.noDataPrompt) {
            this.currentSelectedDBName = "";
            this.currentSelectDBKeyName = "";
          }
          
          // 「処理中」非表示
          this.processDialogue(false);

          // 初期フォーカス設定
          this.$nextTick(() => {
            this.initFocus();
          });
        })
      }
    }
  },

  methods: {
    ...mapMutations("businessModule", [
      "processDialogue",
    ]),

    // 行選択
    selectRow(dbInfo) {
      this.currentSelectedDBName = dbInfo.databaseName;
      this.currentSelectDBKeyName = dbInfo.databaseKeyName;
    },

    // エラー情報初期化
    clearError() {
      this.errors = [];
      this.errors_selectDB = [];
    },

    // 初期フォーカス設定
    initFocus() {
      this.$refs.confirmButton.focus();

      // 表示時に選択されたDB位置へスクロールするように設定
      if (this.currentSelectDBKeyName) {
        let selectedElement = document.getElementById(this.currentSelectDBKeyName);
        this.$refs.cubeBopDbInfoTable.scrollTop = selectedElement.offsetTop;
      }
    },

    // ソートキー変更
    changeSortKey(key) {
      Common.changeSortKey(this.sort, key);
      this.cubeBopDbInfoList = Common.listSort(this.sort.key, this.sort.isAsc, this.cubeBopDbInfoList);
    },
    
    // 日付のフォーマット(YYYY/MM/DD)
    formatDateTime_Date(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD");
      }
    },

    // 日付のフォーマット(HH:mm:ss)
    formatDateTime_Time(value) {
      if (value) {
        return moment(String(value)).format("HH:mm:ss");
      }
    },

    // 確定ボタン押下
    handleConfirm() {
      this.clearError();

      // データベースの選択チェック
      if (!this.currentSelectDBKeyName) {
        this.errors_selectDB.push(
          Common.createError(
            "MTCL1034",
            Common.getMessage("MTCL1034", ["データベース"])
          )
        );
        this.errors.push(
          Common.createError(
            "MTCL1119",
            Common.getMessage("MTCL1119", [])
          )
        );
        return;
      }

      // 選択されたデータベース情報を親画面へ渡し、当画面を閉じる
      this.$emit("update:selectedDBName", this.currentSelectedDBName);
      this.$emit("update:selectedDBKeyName", this.currentSelectDBKeyName);
      this.$emit("changeCubeBopDatabase");
    },

    // キャンセルボタン押下
    handleCancel() {
      this.$emit("update:isBuisinessDBListShow", false);
    },
  }
}
</script>